"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverOrientation = exports.PopoverSize = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var PopoverBody_1 = __importDefault(require("./PopoverBody"));
var PopoverHeading_1 = __importDefault(require("./PopoverHeading"));
var PopoverPositionUtils_1 = __importDefault(require("./PopoverPositionUtils"));
var Icon_1 = __importDefault(require("../icon/Icon"));
var ChildrenUtils_1 = require("../../common/ChildrenUtils");
var DeprecationUtils_1 = require("../../utils/DeprecationUtils");
var PopoverHeadingType = (react_1.default.createElement(PopoverHeading_1.default, null)).type;
var PopoverBodyType = (react_1.default.createElement(PopoverBody_1.default, null)).type;
var PopoverSize;
(function (PopoverSize) {
    PopoverSize["SMALL"] = "fds-popover-sm";
    PopoverSize["MEDIUM"] = "fds-popover-md";
    PopoverSize["LARGE"] = "fds-popover-lg";
})(PopoverSize = exports.PopoverSize || (exports.PopoverSize = {}));
var PopoverOrientation;
(function (PopoverOrientation) {
    PopoverOrientation["TOP"] = "top";
    PopoverOrientation["BOTTOM"] = "bottom";
    PopoverOrientation["LEFT"] = "left";
    PopoverOrientation["RIGHT"] = "right";
})(PopoverOrientation = exports.PopoverOrientation || (exports.PopoverOrientation = {}));
var Popover = /** @class */ (function (_super) {
    __extends(Popover, _super);
    function Popover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.arrow = react_1.default.createRef();
        _this.popover = react_1.default.createRef();
        _this.trigger = react_1.default.createRef();
        _this.wrapper = react_1.default.createRef();
        _this.state = {
            active: false,
            popoverPosition: {},
            arrowPosition: {
                left: '50%' // In case dynamic arrow re-positioning fails
            },
            orientation: PopoverOrientation.TOP
        };
        _this.showPopover = function () {
            // this.setPopoverPosition(() => (this.setState({ active: true })));
            _this.setState({ active: true }, function () { return _this.setPopoverPosition(); });
        };
        _this.hidePopover = function () {
            _this.setState({
                active: false,
                popoverPosition: {}
            });
        };
        _this.onResize = function () {
            _this.state.active && _this.setPopoverPosition();
        };
        _this.onClickOutside = function (e) {
            if (_this.wrapper.current && _this.wrapper.current.contains(e.target)) {
                return;
            }
            var active = _this.state.active;
            var onClickOutside = _this.props.onClickOutside;
            active && onClickOutside && onClickOutside(e);
            active && _this.hidePopover();
        };
        _this.onClickTrigger = function (e) {
            if (_this.popover.current && _this.popover.current.contains(e.target)) {
                return;
            }
            e.stopPropagation();
            var active = _this.state.active;
            var onClickTrigger = _this.props.onClickTrigger;
            if (active) {
                _this.hidePopover();
            }
            else {
                _this.showPopover();
            }
            onClickTrigger && onClickTrigger(e, !active);
        };
        return _this;
    }
    Popover.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onResize);
        document.addEventListener('click', this.onClickOutside, { capture: true });
        this.positionUtils = new PopoverPositionUtils_1.default(this.trigger.current, this.popover.current, this.wrapper.current, {
            showArrow: this.props.showArrow,
            topIntersectionElemId: this.props.topIntersectionElemId
        });
    };
    Popover.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('click', this.onClickOutside, { capture: true });
    };
    Popover.prototype.componentDidUpdate = function (prevProps) {
        // If one or more props have changed, we can't be sure the Popover size is the same, therefore reposition
        // as long as it's currently active
        if (this.state.active && this.props !== prevProps) {
            this.setPopoverPosition();
        }
    };
    Popover.prototype.setPopoverPosition = function (callback) {
        var positionData = this.positionUtils.getPopoverPosition();
        this.setState({
            popoverPosition: positionData.popoverStyle,
            arrowPosition: positionData.arrowStyle,
            orientation: positionData.orientation
        }, callback ? callback : null);
    };
    Popover.prototype.isInline = function () {
        // TODO: Remove in 2.0.0 when `triggerText` and `triggerTextClasses` are removed
        return this.props.triggerText || this.props.label;
    };
    Popover.prototype.getPopoverClassNames = function () {
        var _a;
        return classnames_1.default('fds-popover', (_a = {
                'fds-popover-active': this.state.active
            },
            _a[this.props.popoverSize] = true,
            _a));
    };
    Popover.prototype.getWrapperClassNames = function () {
        return classnames_1.default('fds-popover-wrapper', {
            'fds-popover-trigger': this.isInline(),
            'no-wrap': !this.props.wrap
        });
    };
    Popover.prototype.getButtonClassNames = function () {
        return classnames_1.default('fds-popover-trigger-button', {
            'fds-popover-trigger': !this.isInline(),
            'fds-popover-text-trigger': this.props.textTrigger
        });
    };
    Popover.prototype.render = function () {
        var _this = this;
        var popoverHeading = ChildrenUtils_1.filterChildrenIn(this.props.children, PopoverHeadingType);
        var popoverBody = ChildrenUtils_1.filterChildrenIn(this.props.children, PopoverBodyType);
        // TODO: Remove in 2.0.0 when `triggerText` and `triggerTextClasses` are removed
        var label = this.props.label;
        var labelClasses = this.props.labelClasses;
        if (this.props.triggerText) {
            DeprecationUtils_1.logDeprecatedPropValue({
                component: 'Popover',
                propName: 'triggerText',
                versionStart: '1.3.5',
                versionEnd: '2.0.0',
                seeMsg: '"triggerText" has been replaced for clarity. Use "label" instead.'
            });
            label = this.props.triggerText;
        }
        if (this.props.triggerTextClasses) {
            DeprecationUtils_1.logDeprecatedPropValue({
                component: 'Popover',
                propName: 'triggerTextClasses',
                versionStart: '1.3.5',
                versionEnd: '2.0.0',
                seeMsg: '"triggerTextClasses" has been replaced for clarity. Use "labelClasses" instead.'
            });
            labelClasses = this.props.triggerTextClasses;
        }
        var innerElems = (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("button", __assign({ ref: this.trigger, type: "button", className: this.getButtonClassNames() }, !this.isInline() && { 'data-control': 'fds-popover-click' }, { "aria-label": this.props.ariaLabel, onClick: !this.isInline() ? this.onClickTrigger : null }), this.props.textTrigger ? label : this.props.triggerIcon),
            react_1.default.createElement("span", { ref: this.popover, "data-orientation": this.state.orientation, style: this.state.popoverPosition, className: this.getPopoverClassNames() },
                react_1.default.createElement("span", { className: "fds-popover-inner" },
                    popoverHeading,
                    popoverBody),
                (this.props.showArrow) && (react_1.default.createElement("span", { ref: this.arrow, className: "fds-popover-arrow", style: this.state.arrowPosition })))));
        var getInnerContent = function (labelClasses) {
            var textTrigger = _this.props.textTrigger;
            if (_this.isInline()) {
                return (react_1.default.createElement("span", { className: labelClasses && classnames_1.default(labelClasses) },
                    !textTrigger && label,
                    innerElems));
            }
            return innerElems;
        };
        return (react_1.default.createElement("span", __assign({ ref: this.wrapper }, label && { 'data-control': 'fds-popover-click' }, { className: this.getWrapperClassNames(), onClick: this.isInline() ? this.onClickTrigger : null }), getInnerContent(labelClasses)));
    };
    Popover.defaultProps = {
        ariaLabel: 'Interactive button with icon',
        popoverSize: PopoverSize.SMALL,
        showArrow: true,
        triggerIcon: react_1.default.createElement(Icon_1.default, { name: "info-outline" }),
        wrapAlone: true
    };
    return Popover;
}(react_1.default.Component));
exports.default = Popover;
